import { z } from "zod";

export const RoleSchema = z.enum(["admin", "editor", "viewer"]);
export type Role = z.infer<typeof RoleSchema>;

export const UserSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  entraOid: z.string(),
  email: z.string(),
  displayName: z.string().nullable(),
  role: RoleSchema,
  createdAt: z.string(),
  lastSeenAt: z.string().nullable(),
});
export type User = z.infer<typeof UserSchema>;

export const MeSchema = z.object({
  oid: z.string(),
  role: RoleSchema,
  email: z.string().optional(),
  displayName: z.string().optional(),
  db: UserSchema.nullable(),
});
export type Me = z.infer<typeof MeSchema>;

export const UpdateUserBodySchema = z
  .object({
    role: RoleSchema.optional(),
    displayName: z.string().optional(),
  })
  .refine((v) => v.role !== undefined || v.displayName !== undefined, {
    message: "At least one of `role` or `displayName` is required",
  });
export type UpdateUserBody = z.infer<typeof UpdateUserBodySchema>;

export const UsersListSchema = z.array(UserSchema);
export type UsersList = z.infer<typeof UsersListSchema>;
